class DrawerMenu extends HTMLElement {
  constructor() {
    'use strict';
    super();
    this.el = this;
    this.mainLevel = this.el.querySelector('.drawer-menu__contents');
    this.init();
  }

  updateLevel1Buttons() {
    const level2Open = this.el.querySelector('.drawer-submenu__item.--drilldown.is-open');
    const level1Buttons = this.el.querySelectorAll('.floating-back-btn--level1');
    level1Buttons.forEach(btn => {
      if (level2Open) {
        btn.style.display = 'none';
        btn.style.pointerEvents = 'none';
        btn.style.visibility = 'hidden';
      } else {
        btn.style.display = 'flex';
        btn.style.pointerEvents = 'auto';
        btn.style.visibility = 'visible';
      }
    });
  }

  init() {
    this.firstLevelItemsWithChildren = this.el.querySelectorAll('.drawer-menu__item__input');
    this.firstLevelItemsWithChildren.forEach((input) => {
      input.addEventListener('change', this.toggleMenuItem.bind(this));
    });

    this.closeButtons = this.el.querySelectorAll('[data-close]');
    this.closeButtons.forEach((btn) => {
      btn.addEventListener('click', this.closeAllItems.bind(this));
    });

    this.overlay = this.el.querySelector('[data-overlay]');
    this.overlay.addEventListener('click', this.closeAllItems.bind(this));

    this.secondLevelBackButtons = this.el.querySelectorAll('[data-drawer-submenu-close]');
    this.secondLevelBackButtons.forEach((button) => {
      button.addEventListener('click', this.toggleSubPanel.bind(this));
    });
document.querySelectorAll('.banner-caret').forEach((label) => {
  label.addEventListener('click', (e) => {
    const panelId = label.getAttribute('data-open-panel');
    if (panelId) {
      e.preventDefault();
      const input = document.getElementById(panelId);
      if (input) {
        input.checked = true;
        const accordion = input.closest('[data-accordion-item]');
        if (accordion) {
          accordion.classList.add('is-open');
          const panel = accordion.querySelector('.drawer-subsubmenu__panel');
          if (panel && window.innerWidth <= 1023) {
            panel.getBoundingClientRect();
            panel.style.transition = 'transform 0.3s ease-in-out, opacity 0.3s ease-in-out';
            panel.style.transform = 'translateX(0)';
            panel.style.opacity = '1';
          }
        }
      }
      this.updateLevel1Buttons();
    }
  });
});
    this.subitemOpeners = document.querySelectorAll('[data-drawer-submenu-open]');
    this.subitemOpeners.forEach((button) => {
      button.addEventListener('click', this.toggleMenuItemFromTheme.bind(this));
    });

    setTimeout(() => {
      this.el.classList.add('initialized');
    }, 100);
  }

  closeAllItems(event, skipEl) {
    const checkboxes = this.mainLevel.querySelectorAll('input:checked');
    checkboxes.forEach((checkbox) => {
      if (skipEl && checkbox === skipEl) return;
      checkbox.checked = false;
      const accordion = checkbox.closest('[data-accordion-item]');
      if (accordion) {
        accordion.classList.remove('is-open');
        if (screen.width <= 820) {
          const parent = accordion.closest('.drawer-menu__contents');
          parent.classList.remove('pull-left');
        }
      }
    });
    if (!skipEl) {
      this.mainLevel.classList.remove('has-open-submenu');
    }
  }

  toggleMenuItem(scope) {
    const input = scope.currentTarget || scope;
    if (!input) return;
    if (scope.stopPropagation) scope.stopPropagation();
    this.closeAllItems(scope, input);

    const accordion = input.closest('[data-accordion-item]');
    if (!accordion) return;

    if (screen.width <= 820) {
      const parent = accordion.closest('.drawer-menu__contents');
      parent.classList.toggle('pull-left');
    }

    accordion.classList.toggle('is-open');
    if (accordion.classList.contains('is-open')) {
      this.mainLevel.classList.add('has-open-submenu');
    } else {
      this.mainLevel.classList.remove('has-open-submenu');
    }
    this.updateLevel1Buttons();
  }

  toggleMenuItemFromTheme(scope) {
    let target = false;
    const button = scope.currentTarget || scope;
    const url = button.getAttribute('data-drawer-submenu-open');

    for (const input of this.firstLevelItemsWithChildren) {
      if (input.getAttribute('data-href') === url) {
        target = input;
        break;
      }
    }

    if (!target) return;

    Woolman.ModalsAndDrawers.showModalOrDrawer(this.el.getAttribute('id'));

    const animationFinished = () => {
      this.el.removeEventListener('transitionend', animationFinished);
      const evt = new Event('change');
      target.checked = true;
      target.dispatchEvent(evt);
    };
    this.el.addEventListener('transitionend', animationFinished);
  }

  toggleSubPanel(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const targetSelector = button.getAttribute('data-drawer-submenu-close');
    if (!targetSelector) return;

    const input = document.getElementById(targetSelector);
    if (!input) return;

    const accordion = input.closest('[data-accordion-item]');
    if (!accordion) return;

    const deeperOpen = accordion.querySelector('.drawer-submenu__item.--drilldown.is-open') ||
                       accordion.querySelector('.drawer-submenu__item__input:checked');

    if (deeperOpen) {
  const deeperAccordion = deeperOpen.closest('[data-accordion-item]') || deeperOpen.closest('.drawer-submenu__item');
  const deeperInput = deeperAccordion ? deeperAccordion.querySelector('input') : deeperOpen;
  if (deeperInput) {
    const panel = deeperAccordion ? deeperAccordion.querySelector('.drawer-subsubmenu__panel') : null;
    if (panel && window.innerWidth <= 1023) {
      panel.style.transition = 'transform 0.3s ease-in-out, opacity 0.3s ease-in-out';
      panel.style.transform = 'translateX(100%)';
      panel.style.opacity = '0';
      setTimeout(() => {
        deeperInput.checked = false;
        if (deeperAccordion) deeperAccordion.classList.remove('is-open');
        panel.style.transition = 'none';
      }, 300);
    } else {
      deeperInput.checked = false;
      if (deeperAccordion) deeperAccordion.classList.remove('is-open');
    }
  }
}else {
      input.checked = false;
      accordion.classList.remove('is-open');
      const parentAccordion = accordion.parentElement.closest('[data-accordion-item]');
      if (!parentAccordion) {
        this.mainLevel.classList.remove('has-open-submenu');
      }
    }
    this.updateLevel1Buttons();
  }
}

if (customElements.get('drawer-menu') === undefined) {
  customElements.define('drawer-menu', DrawerMenu);
}